import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ManagmentCardComponent } from '../tableau-de-bord/managment-card/managment-card.component';
import { MatIcon } from '@angular/material/icon';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ERole } from 'src/enum/eRole';

@Component({
    selector: 'app-aide-et-soutien',
    templateUrl: './aide-et-soutien.component.html',
    styleUrls: ['./aide-et-soutien.component.scss'],
    imports: [RouterModule, TranslateModule, ManagmentCardComponent, MatIcon]
})
export class AideEtSoutienComponent {
  rdvUrl = 'https://outlook.office.com/book/PrsentationNovoStudio@novosst.com/?ismsaljsauthenabled';

  conditionsUrl = 'https://www.novostudio.ca/fr-ca/confidentialite';

  constructor(public utilisateurService: UtilisateurService) { }

  get afficherPrendreRv(): boolean {
    const estRoot = this.utilisateurService.selectionEntiteUtilisateur?.estRoot;
    const estRootLectureSeule = this.utilisateurService.selectionEntiteUtilisateur?.estRootLectureSeule;
    const estAdminOuPilote = this.utilisateurService.entiteUtilisateurSelectionnee?.roleEntites
      .some(r => r.roleId === ERole.Pilote || r.roleId === ERole.Admin);

    return estRoot || estRootLectureSeule || estAdminOuPilote;
  }
}
